import { useState, useRef, useEffect } from 'react'

export const Editable = ({
  update = () => {},
  placeholder,
  autoFocus,
  value = '',
  className,
  limit,
  onBlur = () => {},
}) => {
  const inputRef = useRef(null)
  const [inputValue, setInputValue] = useState(value)
  const isNewValue = value !== inputValue

  useEffect(() => {
    if (inputRef && autoFocus && isNewValue) {
      inputRef.current.focus()
    }

    setInputValue(value)
  }, [inputRef, value])

  const updateValue = () => {
    if (isNewValue) {
      update(inputValue)

      // This covers an edge case where the inputValue is changed, but code
      // elsewhere results in the updated value being the same as the original.
      // I don't believe this will ever be a different value than the inputValue
      // but if we ever run into issues down the line, this would be the place to look.
      setInputValue(value)
    }
  }

  const handleBlur = () => {
    updateValue()
    onBlur(inputValue)
  }

  const updateInputValue = ({ target }) => {
    setInputValue(target.value)
  }

  const onKeyUp = ({ key }) => {
    if (key === 'Enter') {
      inputRef.current.blur()
    }
  }

  return (
    <input
      type="text"
      maxLength={limit}
      ref={inputRef}
      onKeyUp={onKeyUp}
      onBlur={handleBlur}
      onWheel={e => e.target.blur()}
      placeholder={placeholder}
      value={inputValue}
      onChange={updateInputValue}
      className={className}
    />
  )
}

// TODO: This can probably be combined with the Editable component
export const EditableLabel = ({
  update = () => {},
  autoFocus = false,
  label,
  placeholder,
  onBlur = update,
  className = '',
  type,
  limit,
  screenType = '',
}) => {
  const defaultLabel =
    placeholder || (!type && `Type ${screenType} name`) || `New ${type}`
  return (
    <Editable
      placeholder={defaultLabel}
      autoFocus={autoFocus}
      limit={limit}
      value={label}
      onBlur={onBlur}
      update={update}
      className={`editable--label editable--label--inputs ${className}`}
    />
  )
}